import { memo } from 'react'

/** Figma "Diamond Warning Error" icon (destructive variant of the bundle-authorization callout). */
export const DiamondWarningIcon = memo((props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M10.0049 1.66992C10.2688 1.66992 10.5306 1.72218 10.7744 1.82324C11.018 1.92427 11.2394 2.07223 11.4258 2.25879L17.751 8.58398C17.9377 8.77051 18.0855 8.99253 18.1865 9.23633C18.2875 9.48004 18.3398 9.74107 18.3398 10.0049C18.3398 10.2688 18.2876 10.5306 18.1865 10.7744C18.0855 11.018 17.9376 11.2394 17.751 11.4258L11.4258 17.751C11.2394 17.9376 11.018 18.0855 10.7744 18.1865C10.5306 18.2876 10.2688 18.3398 10.0049 18.3398C9.74107 18.3398 9.48005 18.2875 9.23633 18.1865C8.99253 18.0855 8.77051 17.9377 8.58398 17.751L2.25879 11.4258C2.07223 11.2394 1.92427 11.018 1.82324 10.7744C1.72218 10.5306 1.66992 10.2688 1.66992 10.0049C1.66994 9.7411 1.72227 9.48002 1.82324 9.23633C1.9243 8.99253 2.07208 8.77051 2.25879 8.58398L8.58398 2.25879C8.7705 2.07209 8.99254 1.9243 9.23633 1.82324C9.48002 1.72227 9.7411 1.66993 10.0049 1.66992ZM10 12.417C9.58579 12.417 9.25 12.7528 9.25 13.167C9.25016 13.5811 9.58589 13.917 10 13.917H10.0098C10.4239 13.917 10.7596 13.5811 10.7598 13.167C10.7598 12.7528 10.424 12.417 10.0098 12.417H10ZM10 5.75C9.58579 5.75 9.25 6.08579 9.25 6.5V10.5C9.25 10.9142 9.58579 11.25 10 11.25C10.4142 11.25 10.75 10.9142 10.75 10.5V6.5C10.75 6.08579 10.4142 5.75 10 5.75Z"
      fill="currentColor"
    />
  </svg>
))
DiamondWarningIcon.displayName = 'DiamondWarningIcon'
